import { useState, useEffect } from 'react';

/**
 * Custom hook for fetching data from Firestore
 * @param {Function} fetchFunction - The Firestore fetch function to execute
 * @returns {Object} - { data, loading, error }
 */
export const useFirestore = (fetchFunction) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await fetchFunction();
                setData(result);
                setError(null);
            } catch (err) {
                console.error('Firestore fetch error:', err);
                setError(err.message || 'An error occurred while fetching data');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [fetchFunction]);

    return { data, loading, error };
};
